import { connector } from "../../common/connector";

export const defaultItem = {
    id: 0,
    nombre: "",
    codigo: "",
    area_id: 0,
    area: {
        id: 0,
        nombre: ""
    },
    pasos: []
}

export const defaultPaso = {
    id: 0,
    tramite_id: 0,
    descripcion: "",
    notificacion: ""
}

export const reducer = (state, action) => {
    switch (action.type) {
        case 'FILL':
            return action.payload;

        case 'ADD':
            return [...state, action.payload];
        
        case 'UPDATE':
            return state.map(it => {
                if(it.id === action.payload.id) { return action.payload; }
                else { return it; }
            });
        
        case 'REMOVE':
            return state.filter(it => it.id != action.payload);

        case 'ADD_PASO': 
            return state.map(it => {
                if(it.id === action.payload.tramite_id) {
                    it.pasos = [...it.pasos, action.payload];
                } 
                return it;   
            });
        
        case 'UPDATE_PASO':
            return state.map(it => {
                if(it.id === action.payload.tramite_id) {
                    it.pasos.map(p => ((p.id === action.payload.id)? it : p));
                }
                return it;
            });

        case 'REMOVE_PASO': 
            return state.map(it => {
                if(it.id === action.payload.tramite_id) {
                    it.pasos = it.pasos.filter(p => p.id !== it.id);
                }
                return it;
            });
        
        default: return state;
    }
}

export const getItems = (params) => {
    return connector.get('api/tramites', { params: params });
}

export const getAreas = () => {
    return connector.get('api/areas');
}

export const createItem = (data) => {
    return connector.post('api/tramites', data);
}

export const updateItem = (data) => {
    return connector.put(`api/tramites/${data.id}`, data)
}

export const deleteItem = (id) => {
    return connector.delete(`api/tramites/${id}`);
}

export const createPaso = (data) => {
    return connector.post(`api/tramite-pasos`, data);
}

export const updatePaso = (data) => {
    return connector.put(`api/tramite-pasos/${data.id}`, data);
}

export const destroyPaso = (id) => {
    return connector.delete(`api/tramite-pasos/${id}`);
}

export const changeno = (data) => {
    return connector.post(`api/tramite-pasos/changeno`, data);
}